import React, { FC } from 'react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import {AnketaIcon} from '../../assets';
import styles from './styles/index.module.scss';

interface IToastInfoContract {
  data: any,
  props?: any
}

const ToastInfoContract: FC<IToastInfoContract> = ({
  data
}) => {
  return (
      <div role='button' tabIndex={0} className={styles['toast-info']} onClick={()=> window.open(`http://${window.location.host + data.url}`)}>
        <GxIcon src={AnketaIcon} className={styles['toast-info--icon']}/>
        <span className={styles['toast-info--text']}>Aнкета: {data.participant}</span>
      </div>
  );
};

export default ToastInfoContract;